import * as Api from '../api';

const api = process.env.REACT_APP_ONB_API;

export const getTimezones = Api.get({ path: '/api/v1/timezones', api });
